"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseTranslation = require("nicbase-translation");

var _filterChips = _interopRequireDefault(require("../filter-chips"));

var _filterableSelectionList = _interopRequireDefault(require("../filterable-selection-list"));

var _excluded = ["hideCoupledAssets", "showHistoricalAssets", "onlyCoupledAssets"],
    _excluded2 = ["selectedRows", "hideCoupledAssets", "showHistoricalAssets", "onlyCoupledAssets"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var sort = function sort(prev, next) {
  var _prev$label;

  return String((_prev$label = prev.label) !== null && _prev$label !== void 0 ? _prev$label : '').localeCompare(next.label);
};

var useAssetFilterList = function useAssetFilterList(_ref) {
  var hideCoupledAssets = _ref.hideCoupledAssets,
      showHistoricalAssets = _ref.showHistoricalAssets,
      onlyCoupledAssets = _ref.onlyCoupledAssets;

  var _usePortal = (0, _nicbaseReducers.usePortal)(),
      portalId = _usePortal.id;

  var _usePortalAssets = (0, _hooks.usePortalAssets)(portalId),
      _usePortalAssets$data = _usePortalAssets.data,
      assets = _usePortalAssets$data === void 0 ? [] : _usePortalAssets$data;

  var _usePortalCoupledAsse = (0, _hooks.usePortalCoupledAssets)(portalId),
      _usePortalCoupledAsse2 = _usePortalCoupledAsse.data,
      coupledAssets = _usePortalCoupledAsse2 === void 0 ? [] : _usePortalCoupledAsse2;

  var _usePortalHistoricalA = (0, _hooks.usePortalHistoricalAssets)(portalId),
      _usePortalHistoricalA2 = _usePortalHistoricalA.data,
      historicalAssets = _usePortalHistoricalA2 === void 0 ? [] : _usePortalHistoricalA2;

  var _usePortalHistoricalC = (0, _hooks.usePortalHistoricalCoupledAssets)(portalId),
      _usePortalHistoricalC2 = _usePortalHistoricalC.data,
      historicalCoupledAssets = _usePortalHistoricalC2 === void 0 ? [] : _usePortalHistoricalC2;

  return (0, _react.useMemo)(function () {
    // only include coupled assets
    if (onlyCoupledAssets) {
      if (showHistoricalAssets) {
        return historicalCoupledAssets.map(function (_ref2) {
          var id = _ref2.id,
              name = _ref2.name;
          return {
            value: id,
            label: name
          };
        }).sort(sort);
      }

      return coupledAssets.map(function (_ref3) {
        var id = _ref3.id,
            name = _ref3.name;
        return {
          value: id,
          label: name
        };
      }).sort(sort);
    } // start with non historical assets only


    var mergedAssets = assets; // include historical and non historical assets

    if (showHistoricalAssets) {
      mergedAssets = historicalAssets;
    }

    if (!hideCoupledAssets) {
      // include historical and non historical coupled assets
      if (showHistoricalAssets) {
        mergedAssets = [].concat(_toConsumableArray(mergedAssets), _toConsumableArray(historicalCoupledAssets));
      } else {
        // include non historical coupled assets
        mergedAssets = [].concat(_toConsumableArray(mergedAssets), _toConsumableArray(coupledAssets));
      }
    }

    return mergedAssets.map(function (_ref4) {
      var id = _ref4.id,
          name = _ref4.name;
      return {
        value: id,
        label: name
      };
    }).sort(sort);
  }, [assets, coupledAssets, hideCoupledAssets, historicalAssets, historicalCoupledAssets, onlyCoupledAssets, showHistoricalAssets]);
};

var AssetSelectionList = function AssetSelectionList(_ref5) {
  var hideCoupledAssets = _ref5.hideCoupledAssets,
      showHistoricalAssets = _ref5.showHistoricalAssets,
      onlyCoupledAssets = _ref5.onlyCoupledAssets,
      other = _objectWithoutProperties(_ref5, _excluded);

  var _usePortal2 = (0, _nicbaseReducers.usePortal)(),
      portalId = _usePortal2.id;

  var onlyHistoricalAssets = (0, _hooks.useOnlyHistoricalAssets)(portalId);
  var assetInfos = useAssetFilterList({
    hideCoupledAssets: hideCoupledAssets,
    showHistoricalAssets: showHistoricalAssets,
    onlyCoupledAssets: onlyCoupledAssets
  });

  var optionRenderer = function optionRenderer(_ref6) {
    var value = _ref6.value,
        label = _ref6.label,
        isSelected = _ref6.isSelected,
        onOptionSelect = _ref6.onOptionSelect;
    var isHistoric = onlyHistoricalAssets.some(function (asset) {
      return asset.id === parseInt(value, 10);
    });
    return /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Checkbox, {
      className: (0, _classnames["default"])({
        'text-gray-500': isHistoric
      }),
      checked: isSelected,
      value: value,
      label: label,
      onChange: onOptionSelect
    });
  };

  return /*#__PURE__*/_react["default"].createElement(_filterableSelectionList["default"], _extends({}, other, {
    data: assetInfos,
    optionRenderer: optionRenderer,
    filterInputLabel: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "filters.searchAsset"
    })
  }));
};

AssetSelectionList.propTypes = _objectSpread(_objectSpread({}, _filterableSelectionList["default"].propTypes), {}, {
  hideCoupledAssets: _propTypes["default"].bool,
  showHistoricalAssets: _propTypes["default"].bool,
  onlyCoupledAssets: _propTypes["default"].bool
});
AssetSelectionList.defaultProps = _objectSpread(_objectSpread({}, _filterableSelectionList["default"].defaultProps), {}, {
  hideCoupledAssets: false,
  showHistoricalAssets: false,
  onlyCoupledAssets: false
});

var AssetChips = function AssetChips(_ref7) {
  var selectedRows = _ref7.selectedRows,
      hideCoupledAssets = _ref7.hideCoupledAssets,
      showHistoricalAssets = _ref7.showHistoricalAssets,
      onlyCoupledAssets = _ref7.onlyCoupledAssets,
      other = _objectWithoutProperties(_ref7, _excluded2);

  var assetInfos = useAssetFilterList({
    hideCoupledAssets: hideCoupledAssets,
    showHistoricalAssets: showHistoricalAssets,
    onlyCoupledAssets: onlyCoupledAssets
  });
  var chipData = selectedRows.map(function (value) {
    return assetInfos === null || assetInfos === void 0 ? void 0 : assetInfos.find(function (asset) {
      return asset.value === value;
    });
  }).filter(function (asset) {
    return asset;
  });
  return /*#__PURE__*/_react["default"].createElement(_filterChips["default"], _extends({}, other, {
    data: chipData
  }));
};

AssetChips.propTypes = _objectSpread(_objectSpread({}, _filterChips["default"].propTypes), {}, {
  selectedRows: _propTypes["default"].arrayOf(_propTypes["default"].number),
  hideCoupledAssets: _propTypes["default"].bool,
  showHistoricalAssets: _propTypes["default"].bool,
  onlyCoupledAssets: _propTypes["default"].bool
});
AssetChips.defaultProps = _objectSpread(_objectSpread({}, _filterChips["default"].defaultProps), {}, {
  selectedRows: [],
  hideCoupledAssets: false,
  showHistoricalAssets: false,
  onlyCoupledAssets: false
});
AssetSelectionList.Chips = AssetChips;
var _default = AssetSelectionList;
exports["default"] = _default;